import { AuthProviderProps } from 'react-oidc-context';

const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL;
const keycloakRealm = import.meta.env.VITE_KEYCLOAK_REALM;
const keycloakClient = import.meta.env.VITE_KEYCLOAK_CLIENT;
const keycloakIdpHint = import.meta.env.VITE_IDP_HINT;
const redirectUrl = import.meta.env.VITE_REDIRECT_URL;
const environment = import.meta.env.VITE_ENVIRONMENT;

const getLogoutRedirectUrl = () => {
  return environment === 'local'
    ? window.location.origin
    : `${import.meta.env.VITE_IDP_URL}openid_connect/logout?client_id=${import.meta.env.VITE_IDP_CLIENT_ID}&post_logout_redirect_uri=${redirectUrl}`;
};

export const oidcConfig: AuthProviderProps = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  client_id: keycloakClient,
  redirect_uri: redirectUrl,
  post_logout_redirect_uri: getLogoutRedirectUrl(),
  response_type: 'code',
  scope: 'openid profile email',

  extraQueryParams: {
    kc_idp_hint: keycloakIdpHint,
  },

  // Advanced configuration
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 30,
  includeIdTokenInSilentRenew: true,

  // Handle the callback after login
  onSigninCallback: (): void => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    // Remove OIDC-specific parameters
    const paramsToRemove = [
      'code',
      'state',
      'session_state',
      'iss', // Issuer (sometimes present)
      'error', // Error parameter (if any)
      'error_description',
    ];

    paramsToRemove.forEach((param) => searchParams.delete(param));

    // Construct clean URL
    const cleanUrl = `${url.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}${url.hash}`;

    // Replace current URL without triggering navigation
    window.history.replaceState({}, document.title, cleanUrl);
  },
};
